import { isValidZip } from '@/features/shared/utils/validator'
import { z } from 'zod'

export const isEmailAddress = (string: string) => {
  const regex = /^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/

  return regex.test(string)
}

export const ungatedWebFormSchema = z.object({
  first_name: z.string().trim().min(1, 'First name is required'),
  last_name: z.string().trim().min(1, 'Last name is required'),
  email: z.string().trim().min(1, 'Email is required').email('Please enter a valid email address'),
  zip_code: z
    .string()
    .optional()
    .refine((val) => !val || isValidZip(val), {
      message: 'Zip code must be 5 digits',
    }),
  email_consent: z.boolean().refine((val) => val, { message: 'Email consent is required' }),
})

export type UngatedWebFormData = z.infer<typeof ungatedWebFormSchema>
